import { gql } from 'apollo-boost';

export const GROUP_UPDATE_GQL = gql`
  mutation GroupUpdate(
    $groupId: ID!
    $name: String
    $toAdd: [ID!]
    $toRemove: [ID!]
  ) {
    group_update(input: { id: $groupId, dancerIdsToAdd: $toAdd, dancerIdsToRemove: $toRemove, name: $name }) {
      group {
        id
        name
        number_of_dancers
        dancers_paginated {
          nodes {
            id
          }
        }
        business {
          id
          timezone
          longitude
          latitude
        }
      }
    }
  }
`;
